import React from 'react';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';
import { HeadlineStats } from 'Storybook/components/local/HeadlineStats';

import styles from './Header.scss';

const Header = () => (
  <div className={styles.container}>
    <Content>
      <h1 className={styles.title}>
        {T.translate('aboutPage.header.title')}
      </h1>
      <p data-thc-style-override className={styles.description}>{T.translate('aboutPage.header.description')}</p>
      <div className={styles.stats}>
        <HeadlineStats stats={[
          {
            stat: String(T.translate('aboutPage.header.stats.0.stat')),
            subtitle: T.translate('aboutPage.header.stats.0.subtitle'),
          },
          {
            stat: String(T.translate('aboutPage.header.stats.1.stat')),
            subtitle: T.translate('aboutPage.header.stats.1.subtitle'),
          },
          {
            stat: String(T.translate('aboutPage.header.stats.2.stat')),
            subtitle: T.translate('aboutPage.header.stats.2.subtitle'),
          },
          {
            stat: String(T.translate('aboutPage.header.stats.3.stat')),
            subtitle: T.translate('aboutPage.header.stats.3.subtitle'),
          },
        ]} />
      </div>
    </Content>
  </div>
);

export default Header;
